import { createContext } from 'react';

interface TextInputGroupContextType {
  index: number;
  isFirst: boolean;
  isLast: boolean;
}

export const TextInputGroupContext = createContext<TextInputGroupContextType | null>(null);
